module.exports = __webpack_public_path__ + "img/VU-LOGO.644c6df2.png";